import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { ILegacyMigrateRequest, ILegacyMigrateResponse } from '../../../entity/interface/iUserApis';

export interface ILegacyMigrateGenerateUseCase {
    execute(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse>;
}

export class LegacyMigrateGenerateUseCase implements ILegacyMigrateGenerateUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse> {
        return await this.userRepo.legacyMigrateGenerate(payload, authToken, authSign, csrfToken);
    }
}
